import Swal from "sweetalert2";

/**
 * Valida que un conjunto de campos requeridos no estén vacíos.
 * @param {Object} campos - Objeto con los valores a validar { nombre_campo: valor }
 * @param {String} mensajeError - Mensaje a mostrar en el SweetAlert si falla
 * @returns {Boolean} true si pasa la validación, false si falla.
 */
export const validarRequeridos = (campos, mensajeError = "Debe completar todos los campos obligatorios.") => {
  for (const valor of Object.values(campos)) {
    if (valor === null || valor === undefined || (typeof valor === 'string' && valor.trim() === '')) {
      Swal.fire("Datos incompletos", mensajeError, "warning");
      return false;
    }
  }
  return true;
};

/**
 * Valida que al menos UNO de los campos en el array tenga valor.
 * @param {Array} campos - Array de valores a comprobar [valor1, valor2]
 * @param {String} mensajeError - Mensaje a mostrar si todos están vacíos
 * @returns {Boolean} true si al menos uno tiene valor.
 */
export const validarAlMenosUno = (campos, mensajeError = "Debe completar al menos un campo de este grupo.") => {
  const tieneValor = campos.some(valor => valor !== null && valor !== undefined && valor.toString().trim() !== '');
  if (!tieneValor) {
    Swal.fire("Datos incompletos", mensajeError, "warning");
    return false;
  }
  return true;
};
